import { render } from "./privacy.vue?vue&type=template&id=682f68d5&bindings={\"navigate\":\"props\"}"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./privacy.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script